export interface User {
  email: string;
  phone: string;
  first_name: string;
  last_name: string;
  retail_user_id?: number;
}

export enum USER_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum USER_PERMISSIONS {
  FAKEORDER_ACCESS = "FAKEORDER_ACCESS",
  EDIT_USER = "EDIT_USER",
  SUPPLIER_ACCESS = "SUPPLIER_ACCESS",
  FINANCIAL_ACCESS = "FINANCIAL_ACCESS",
  COMPETITIVE_PRICE_ACCESS = "COMPETITIVE_PRICE_ACCESS",
  CHARM_PRICE_ACCESS = "CHARM_PRICE_ACCESS",
  SELL_PRICES_ACCESS = "SELL_PRICES_ACCESS",
  PROMOTION_ACCESS = "PROMOTION_ACCESS",
  SAMPLING_ACCESS = "SAMPLING_ACCESS",
  WISHLIST_ACCESS = "WISHLIST_ACCESS",
  PACKS_ACCESS = "PACKS_ACCESS",
  LABEL_ACCESS = "LABEL_ACCESS",
  PRICE_MANAGER_ACCESS = "PRICE_MANAGER_ACCESS",
  PRICING_ACCESS = "PRICING_ACCESS",
  MARKUP_ACCESS = "MARKUP_ACCESS",
  COMPLEX_DISCOUNT_ACCESS = "COMPLEX_DISCOUNT_ACCESS",
  CARGO_INVOICE = "CARGO_INVOICE",
  SUPPLY_EXECUTION = "SUPPLY_EXECUTION",
  SUPPLY_PLANNING = "SUPPLY_PLANNING",
  BULK_UPLOAD_ACCESS = "BULK_UPLOAD_ACCESS",
  RESTRICT_LIST_ACCESS = "RESTRICT_LIST_ACCESS",
  SUPPLY_PURCHASE_ORDER_ACCESS = "SUPPLY_PURCHASE_ORDER_ACCESS",
  SUPPLY_TRANSFER_ORDERS_ACCESS = "SUPPLY_TRANSFER_ORDERS_ACCESS",
  AUDIT_INVENTORY_ACCESS = "AUDIT_INVENTORY_ACCESS",
  REPLENISHMENT_ACCESS = "REPLENISHMENT_ACCESS",
  ALL_SUPPLIER_ACCESS = "ALL_SUPPLIER_ACCESS",
  AUDIT_ACCESS = "AUDIT_ACCESS",
  ORDER_TRACKING_ACCESS = "ORDER_TRACKING_ACCESS",
  REALTIME_FAKE_ORDERS_ACCESS = "REALTIME_FAKE_ORDERS_ACCESS",
  CONTROL_PANEL_ACCESS = "CONTROL_PANEL_ACCESS",
  ACCURACY_TRACKER_ACCESS = "ACCURACY_TRACKER_ACCESS",
  POS_ACCESS = "POS_ACCESS",
  TURBOX_ASSOCIATIONS_ACCESS = "TURBOX_ASSOCIATIONS_ACCESS",
  COLD_PRODUCTS_ACCESS = "COLD_PRODUCTS_ACCESS",
  SUPPLY_INVENTORY_ACCESS = "SUPPLY_INVENTORY_ACCESS",
  SUPPLY_TRANSFORMATIONS_ACCESS = "SUPPLY_TRANSFORMATIONS_ACCESS",
  CYCLICS_ACCESS = "CYCLICS_ACCESS",
  WAREHOUSE_CAPACITY_ACCESS = "WAREHOUSE_CAPACITY_ACCESS",
  CATALOG_ACCESS = "CATALOG_ACCESS",
  WAREHOUSE_CONFIG_ACCESS = "WAREHOUSE_CONFIG_ACCESS",
  KPI_ACCESS = "KPI_ACCESS",
  PRICE_LIST_ACCESS = "PRICE_LIST_ACCESS",
  CATMAN_PRICE_LIST_ACCESS = "CATMAN_PRICE_LIST_ACCESS",
  PERMISSION_ACCESS = "PERMISSION_ACCESS",
  ROLE_ACCESS = "ROLE_ACCESS",
  ORDER_MONITORING_ACCESS = "ORDER_MONITORING_ACCESS",
  SALE_INVOICE_ACCESS = "SALE_INVOICE_ACCESS",
  REPROCESS_SALE_ORDERS = "REPROCESS_SALE_ORDERS",
  CATEGORIES_ACCESS = "CATEGORIES_ACCESS",
  PARAMETER_CONFIGURATION_ACCESS = "PARAMETER_CONFIGURATION_ACCESS",
  ONBOARDING_ACCESS = "ONBOARDING_ACCESS",
  SELF_ONBOARDING_ACCESS = "SELF_ONBOARDING_ACCESS",
  CATMAN_ONBOARDING_ACCESS = "CATMAN_ONBOARDING_ACCESS",
  DATA_MASTER_ONBOARDING_ACCESS = "DATA_MASTER_ONBOARDING_ACCESS",
  PICKER_SCHEDULE_ACCESS = "PICKER_SCHEDULE_ACCESS",
  SUPPLIER_MANAGEMENT_ACCESS = "SUPPLIER_MANAGEMENT_ACCESS",
  PAYMENTS_ACCESS = "PAYMENTS_ACCESS",
  MULTIBRAND_ACCESS = "MULTIBRAND_ACCESS",
  STORE_ACCESS = "STORE_ACCESS",
  FRONT_MARGINS_ACCESS = "FRONT_MARGINS_ACCESS",
  SUPPLIER_ADMIN_ACCESS = "SUPPLIER_ADMIN_ACCESS",
  CONSIGMENT_ORDERS_ACCESS = "CONSIGMENT_ORDERS_ACCESS",
  PRODUCT_VISIBILITY_ACCESS = "PRODUCT_VISIBILITY_ACCESS",
  HOME_KUSTOMER = "HOME_KUSTOMER",
  PURCHASE_ORDERS_ACCESS = "PURCHASE_ORDERS_ACCESS",
  SUPPLIER_AGREEMENTS_ACCESS = "SUPPLIER_AGREEMENTS_ACCESS",
  SUPPLIER_METRICS_ACCESS = "SUPPLIER_METRICS_ACCESS",
  ROTATION_MANAGER_ACCESS = "ROTATION_MANAGER_ACCESS",
}

export interface IUserStatusItem {
  value: keyof typeof USER_STATUS;
  label: string;
}

export interface IUserPermissionsItem {
  value: keyof typeof USER_PERMISSIONS;
  label: string;
}

export interface IRedirectDefaultItem {
  role: keyof typeof USER_PERMISSIONS;
  path: string;
}
